module.exports = __webpack_public_path__ + "img/Logo_Hor_Orange.a36b3bf3.png";